export function ModulFHoverStyles({ colors }) {
    return {
        hoverStyle: `0 0 0 2px ${colors.interaction.hover.color}`,
        hoverStyleInset: `inset 0 0 0 2px ${colors.interaction.hover.color}`
    };
}
